import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { apiFetch, getTheme, noSelect, timestamp } from 'helpers'
import moment from 'moment'
import { get, isEqual } from 'lodash'
import Loader, { LoaderWrapper } from 'components/Loader'
import { Button } from 'components/Form'
import { ItemWrapper, BtnSquareAdd, getItemWrapperWidth } from 'components/profile/Section'
import { ObjectID } from 'bson'
import { uploadFile, viewportWidth, viewportHeight } from '../helpers'
import AspectRatioImage, { AspectRatioImageContainer } from 'components/AspectRatioImage'
import Modal, { Overlay, ConfirmDialog } from 'components/Modal'
import HorizontalCentered from 'components/HorizontalCentered'
import VerticalCentered from 'components/VerticalCentered'

import { List, InfiniteLoader, CellMeasurer, CellMeasurerCache } from 'react-virtualized'

import svgCloseWhite from 'assets/svg/icon-close-white.svg'
import svgLoading from 'assets/svg/icon-loading-tiffany.svg'

@connect(state => ({
  me: get(state, 'vendor.me')
}))
export default class extends Component {
  constructor (props) {
    super(props)
    this.state = {
      copied: false,
      reviewSummary: [],
      reviews: [],
      photoCount: 0,
      photos: []
    }
  }

  componentDidMount () {
    const { me } = this.props
    this.setState({ loading: true }, () =>
      Promise.all([
        apiFetch({ v4: true, url: `/v4/reviews/${get(me, '_id')}/group-by-score` }),
        apiFetch({ v4: true, url: '/v4/reviews', query: { vendorId: get(me, '_id'), limit: 24 } }),
        // apiFetch({ url: '/v3/review-photos/count', query: { ownerId: get(me, '_id') } }),
        // apiFetch({ url: '/v3/review-photos', query: { ownerId: get(me, '_id') } })
      ])
        .then(([reviewSummary, reviews]) => this.setState({ loading: false, reviewSummary, reviews }))
        .catch(error => this.setState({ loading: false, error }))
    )
  }

  componentDidUpdate (prevProps, prevState) {
    if (!isEqual(this.state.reviews, prevState.reviews)) {
      const index = prevState.reviews.length
      this._cache.clear(index, 0)
      if (this._list) {
        this._list.recomputeRowHeights(index)
      }
    }
  }

  _onCopyLink = () => {
    const { me } = this.props
    const tempInput = document.createElement('input')
    tempInput.style = 'position: absolute; left: -10000px; top: -10000px;'
    tempInput.value = `https://www.sabuywedding.com/${get(me, 'venueCategory._id') ? 'venues' : 'vendors'}/${get(me, 'routeUrl')}/reviews/write`
    document.body.appendChild(tempInput)
    tempInput.select()
    document.execCommand('Copy')
    document.body.removeChild(tempInput)
    this.setState({ copied: true })
    setTimeout(() => this.setState({ copied: false }), 1500)
  }

  // _onAddReviewPhoto = (e) => {
  //   const files = Object.keys(e.target.files).map(key => e.target.files[key])
  //   files.reduce((promise, file, index) =>
  //     promise.then(() => {
  //       const photoId = new ObjectID().toString()
  //       this.setState({ photoCount: this.state.photoCount + 1, photos: (this.state.photos || []).concat({ _id: photoId }) },
  //         () =>
  //           uploadFile({
  //             url: '/v3/review-photos',
  //             method: 'POST',
  //             fieldName: 'photo',
  //             file,
  //             body: { photoId, ownerId: get(this.props, 'me._id') },
  //             actionParams: { file }
  //           })
  //             .then(result => {
  //               this.setState({
  //                 photos: this.state.photos.map(photo =>
  //                   photo._id === result._id ? result : photo
  //                 )
  //               })
  //               return Promise.resolve()
  //             })
  //       )
  //     })
  //     , Promise.resolve())
  // }

  // _onRemovePhoto = () => {
  //   const photoId = this.state.removingPhotoId || get(this.state, 'currentPhoto._id')
  //   this.setState({ removing: true }, () =>
  //     apiFetch({
  //       url: `/v3/review-photos/${photoId}`,
  //       method: 'DELETE'
  //     })
  //       .then(() => this.setState({
  //         removing: false,
  //         confirmRemoveVisible: false,
  //         photoCount: this.state.photoCount - 1,
  //         photos: this.state.photos.filter(_photo => _photo._id !== photoId)
  //       }))
  //       .catch(() => this.setState({ removing: false }))
  //   )
  // }

  _cache = new CellMeasurerCache({ defaultHeight: 85, fixedWidth: true })
  _isRowLoaded = ({ index }) => index < this.state.reviews.length
  _listWidth = () => Math.min(viewportWidth() * 0.8, 1080)
  _listHeight = () => viewportHeight() * 0.8

  _onLoadMoreReviews = () =>
    this.setState({ loadingMore: true }, () =>
      apiFetch({
        v4: true,
        url: '/v4/reviews',
        query: {
          vendorId: get(this.props, 'me._id'),
          limit: 24,
          skip: this.state.reviews.length
        }
      })
        .then(nextReviews => this.setState({ loadingMore: false, reviews: this.state.reviews.concat(nextReviews) }))
        .catch(error => this.setState({ loadingMore: false, error }))
    )

  _rowRenderer = ({ index, isScrolling, key, parent, style }) =>
    <CellMeasurer
      cache={this._cache}
      columnIndex={0}
      key={key}
      parent={parent}
      rowIndex={index}
      width={this._listWidth()}>
      <div style={style}>{index >= this.state.reviews.length ? (
        <RowLoading>
          {this.state.loadingMore && <IconLoading src={svgLoading} />}
        </RowLoading>
      ) : (
        <div style={index > 0 ? { borderTop: '1px solid #e6e6e6' } : {}}>
          <ReviewItem review={this.state.reviews[index]} />
        </div>
      )}</div>
    </CellMeasurer>

  render () {
    const summaryMap = (this.state.reviewSummary || []).reduce((map, summary) => {
      const key = `${Math.ceil(summary._id)}`
      return {
        ...map,
        totalCount: map.totalCount + summary.count,
        totalScore: map.totalScore + (summary.count * key),
        [key]: (map[key] || 0) + summary.count
      }
    }, { totalCount: 0, totalScore: 0 })
    const photoWidth = getItemWrapperWidth()
    return (
      <Section>
        <Box>
          <Header>
            <div>Rating & Reviews</div>
          </Header>
          {Boolean(this.state.reviews.length) && (
            <Description>
              <span>คุณสามารถส่งลิงก์รีวิวให้เจ้าสาวเพื่อเพิ่มรีวิวได้</span>
              <BtnCopyLink copied={this.state.copied} onClick={this._onCopyLink}>{this.state.copied ? 'Copied!' : 'Copy Link'}</BtnCopyLink>
            </Description>
          )}
          <ReviewSummary>
            <AverageScore>{(summaryMap.totalScore / (summaryMap.totalCount || 1)).toFixed(1)}</AverageScore>
            <ReviewGroups>
              {(Array(5).fill().map((_, i) =>
                <ReviewGroup key={i}>
                  {(Array(i).fill(0).concat(Array(5 - i).fill(1))).map((active, index) =>
                    <StarWrapper key={index}>
                      <img alt='star' src={`/images/star-icon-${active ? 10 : 0}.png`} />
                    </StarWrapper>
                  )}
                  <ScoreLine percent={100 * (summaryMap[5 - i] || 0) / summaryMap.totalCount} />
                  <ScoreValue>{(summaryMap[5 - i] || 0)}</ScoreValue>
                </ReviewGroup>
              ))}
            </ReviewGroups>
          </ReviewSummary>
          <Reviews>
            <Header style={{ marginTop: 20 }}>
              <span>{summaryMap.totalCount} Reviews</span>
              {summaryMap.totolCount && <BtnViewMore onClick={() => this.setState({ reviewsModalVisible: true })}>ดูทั้งหมด</BtnViewMore>}
            </Header>
            {this.state.loading ? (
              <ReviewItems>
                {Array(2).fill().map((e, i) => <ReviewItem key={i} loading />)}
              </ReviewItems>
            ) : !this.state.reviews.length ? (
              <ReviewItems>
                <NoReviewsFound>
                  <div>ไม่พบรีวิว :(</div>
                  <div style={{ marginBottom: 30 }}>คุณสามารถส่งลิงก์รีวิวให้เจ้าสาวเพื่อเพิ่มรีวิวได้</div>
                  <Button small style={{ width: 200 }} onClick={this._onCopyLink}>{this.state.copied ? 'Copied!' : 'Copy Link'}</Button>
                </NoReviewsFound>
              </ReviewItems>
            ) : (
              <ReviewItems>
                {(this.state.reviews || []).map(review => <ReviewItem key={review._id} review={review} />)}
              </ReviewItems>
            )}
          </Reviews>
          <Overlay visible={this.state.reviewsModalVisible}
            onClose={() => this.setState({ reviewsModalVisible: false })}>
            <HorizontalCentered>
              <VerticalCentered>
                <Modal style={{ width: this._listWidth(), height: this._listHeight() + 41 }} noPadding
                  title={`รีวิวทั้งหมด (${summaryMap.totalCount} รีวิว)`}
                  onClose={() => this.setState({ reviewsModalVisible: false })}>
                  <InfiniteLoader
                    isRowLoaded={this._isRowLoaded}
                    loadMoreRows={this._onLoadMoreReviews}
                    rowCount={this.state.reviews.length + 1}>
                    {({ onRowsRendered, registerChild }) =>
                      <List
                        width={this._listWidth()}
                        height={this._listHeight()}
                        onRowsRendered={onRowsRendered}
                        rowRenderer={this._rowRenderer}
                        ref={registerChild}
                        rowCount={this.state.reviews.length + 1}
                        rowHeight={this._cache.rowHeight} />
                    }
                  </InfiniteLoader>
                </Modal>
              </VerticalCentered>
            </HorizontalCentered>
          </Overlay>
        </Box>
        <Separator />
        {false && (
          <Box>
            <Header>Review Photos {this.state.loading ? '' : `(${this.state.photoCount})`}</Header>
            <div>
              <ItemWrapper desktop>
                <BtnSquareAdd width={photoWidth} title='เพิ่มรีวิวรูปภาพ' onClick={() => this.refs.fileChooser.click()} />
                <input multiple type='file' ref='fileChooser' style={{ display: 'none' }}
                  accept='image/*' onChange={this._onAddReviewPhoto} />
              </ItemWrapper>
              {(this.state.photos || []).map(photo =>
                <ItemWrapper key={photo._id}>
                  <PhotoWrapper>
                    <AspectRatioImage src={photo.imagePath} />
                    <BtnRemove onClick={() => this.setState({ confirmRemoveVisible: true, removingPhotoId: photo._id })}>
                      <IconRemove src={svgCloseWhite} />
                    </BtnRemove>
                  </PhotoWrapper>
                </ItemWrapper>
              )}
              <Overlay visible={this.state.confirmRemoveVisible}
                onClose={() => this.setState({ confirmRemoveVisible: false })}>
                <ConfirmDialog title='คุณต้องการลบรูปภาพนี้ ?'
                  loading={this.state.removing}
                  onOkay={this._onRemovePhoto}
                  onCancel={() => this.setState({ confirmRemoveVisible: false })} />
              </Overlay>
            </div>
          </Box>
        )}
      </Section>
    )
  }
}

const Section = styled.section`
  @media(min-width: 1080px) {
    width: 100%;
    margin: 0 auto;
    max-width: 1080px;
    padding: 30px 0px;
  }
  @media(min-width: 768px) and (max-width: 1079px) {
    width: calc(100% - 20px);
    margin: 0px 10px;
    padding: 30px 0px;
  }
`
const Box = styled.div`
  background-color: white;
  position: relative;
  overflow: hidden;

  @media(min-width: 1100px) {
    box-shadow: 0px 2px 2px rgba(173, 173, 173, 0.5);
    padding: 25px 20px;
    margin-bottom: 15px;
    border-radius: 5px;
  }
  @media(max-width: 1099px) {
    padding-top: 15px;
    padding-bottom: 20px;
    ${props => props.withPadding && `
      width: calc(100% - 20px);
      padding-left: 10px;
      padding-right: 10px;
    `}
  }
`
const Separator = styled.div`
  @media(max-width: 1099px) {
    height: 10px;
    background-color: ${getTheme`colorBackground`};
  }
`
const RowLoading = styled.div`
  text-align: center;
  padding-bottom: 20px;
`
const IconLoading = styled.img`
  width: 30px;
  height: 30px;
  vertical-align: top;
`

const Header = styled.div`
  position: relative;
  color: black;
  font-size: 20px;
  line-height: 30px;
  position: relative;

  > span {
    display: inline-block;
    vertical-align: top;
  }

  @media(max-width: 479px) {
    width: calc(100% - 20px);
    margin: 0px 10px;
  }
`
const Description = styled.div`
  font-size: 16px;
  font-weight: 300;
  line-height: 30px;
  > span {
    display: inline-block;
    vertical-align: top;
    margin-right: 10px;
  }
  @media(max-width: 479px) {
    width: calc(100% - 20px);
    margin: 0px 10px;
  }
`
const BtnViewMore = styled.div`
  display: inline-block;
  vertical-align: top;
  margin-top: 2px;
  margin-left: 10px;
  color: ${getTheme`colorTiffany`};
  font-size: 16px;
  cursor: pointer;
  &:hover { text-decoration: underline; }
`

const BtnCopyLink = styled.div`
  display: inline-block;
  vertical-align: top;
  transition: opacity 0.3s ease;
  &:hover { opacity: 0.8; }
  cursor: pointer;
  ${noSelect};
  line-height: 30px;
  height: 30px;
  width: 90px;
  border-radius: 5px;
  font-size: 16px;
  background-color: ${getTheme`colorTiffany`};
  text-align: center;
  color: white;
  ${props => props.copied ? '' : `box-shadow: 0px 2px 2px ${props.theme.colorBorder}`};
`

const ReviewSummary = styled.section`
  border-bottom: 1px solid ${getTheme`colorBorder`};
  @media(min-width: 768px) { padding: 30px; }
  @media(min-width: 415px) and (max-width: 767px) {
    margin-top: 15px;
    padding: 20px;
  }
  @media(max-width: 414px) {
    margin-top: 15px;
    padding: 10px;
  }
`
const AverageScore = styled.div`
  display: inline-block;
  vertical-align: top;
  text-align: center;
  border-radius: 50%;
  background-image: linear-gradient(-180deg, #FFE13B 0%, #FFBF04 99%);
  
  font-family: ${getTheme`font1`};
  font-weight: ${getTheme`weightLight`};
  color: white;

  @media(min-width: 768px) {
    width: 120px;
    height: 120px;
    line-height: 120px;
    font-size: 66px;
    letter-spacing: -7px;
    text-indent: -10px;
    margin-top: 20px;
  }
  @media(min-width: 415px) and (max-width: 767px) {
    width: 100px;
    height: 100px;
    line-height: 100px;
    font-size: 51px;
    letter-spacing: -5px;
    text-indent: -8px;
  }
  @media(max-width: 414px) {
    width: 80px;
    height: 80px;
    line-height: 80px;
    font-size: 36px;
    letter-spacing: -3px;
    text-indent: -6px;
  }
`
const ReviewGroups = styled.div`
  display: inline-block;
  vertical-align: top;
  @media(min-width: 768px) {
    width: calc(100% - 195px);
    margin-left: 45px;
  }
  @media(min-width: 415px) and (max-width: 767px) {
    width: calc(100% - 140px);
    margin-left: 30px;
  }
  @media(max-width: 414px) {
    width: calc(100% - 95px);
    margin-left: 15px;
  }
`
const ReviewGroup = styled.div`
  @media(min-width: 768px) {
    height: 20px;
    margin-bottom: 16px;
  }
  @media(min-width: 415px) and (max-width: 767px) {
    height: 15px;
    margin-bottom: 12px;
  }
  @media(max-width: 414px) {
    height: 10px;
    margin-bottom: 8px;
  }
`
const StarWrapper = styled.div`
  display: inline-block;
  vertical-align: top;
  margin-right: 5px;

  @media(min-width: 768px) {
    line-height: 20px;
    > img { width: 20px; height: 20px; }
  }
  @media(min-width: 415px) and (max-width: 767px) {
    line-height: 15px;
    > img { width: 15px; height: 15px; }
  }
  @media(max-width: 414px) {
    line-height: 10px;
    > img { width: 10px; height: 10px; }
  }
`
const ScoreLine = styled.div`
  display: inline-block;
  vertical-align: top;
  border-radius: 100px;
  background-color: ${getTheme`colorGrayInactiveStar`};
  position: relative;
  overflow: hidden;
  &:after {
    content: '';
    background: ${getTheme`colorOrange`};
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    ${props => `
      transition: right 1s ease;
      right: ${(100 - props.percent)}%;
    `}
  }

  @media(min-width: 768px) {
    margin-left: 50px;
    margin-right: 25px;
    width: calc(100% - 240px);
    height: 8px;
    margin-top: 6px;
  }
  @media(min-width: 415px) and (max-width: 767px) {
    margin-left: 30px;
    margin-right: 18px;
    width: calc(100% - 180px);
    height: 6px;
    margin-top: 4px;
  }
  @media(max-width: 414px) {
    margin-left: 10px;
    margin-right: 10px;
    width: calc(100% - 121px);
    height: 4px;
    margin-top: 2px;
  }
`
const ScoreValue = styled.div`
  display: inline-block;
  vertical-align: top;
  text-align: left;
  font-family: ${getTheme`font1`};
  color: black;
  @media(min-width: 768px) {
    width: 40px;
    font-size: 18px;
    line-height: 20px;
  }
  @media(min-width: 415px) and (max-width: 767px) {
    width: 32px;
    font-size: 15px;
    line-height: 15px;
  }
  @media(max-width: 414px) {
    width: 20px;
    font-size: 12px;
    line-height: 10px;
  }
`
const Reviews = styled.section``
const ReviewItems = styled.div`
  padding: 20px;
  padding-top: 0px;
`
const NoReviewsFound = styled.div`
  color: ${getTheme`colorGray`};
  text-align: center;
  font-size: 18px;
  line-height: 30px;
`

const ReviewItem = ({ loading, review }) => {
  if (loading) {
    return (
      <ReviewItemWrapper>
        <Reviewer>
          <ReviewerImageWrapper>
            <Loader width={48} height={48} />
          </ReviewerImageWrapper>
          <ReviewerInfo>
            <LoaderWrapper style={{ width: 80, height: 24, marginBottom: 5 }}>
              <Loader width={80} height={24} />
            </LoaderWrapper>
            <LoaderWrapper style={{ width: 150, height: 20 }}>
              <Loader width={150} height={20} />
            </LoaderWrapper>
          </ReviewerInfo>
        </Reviewer>
        <ReviewComment>
          <LoaderWrapper style={{ height: 22, marginBottom: 5 }}>
            <Loader width={100} height={100} />
          </LoaderWrapper>
          <LoaderWrapper style={{ height: 22 }}>
            <Loader width={100} height={100} />
          </LoaderWrapper>
        </ReviewComment>
      </ReviewItemWrapper>
    )
  }
  const reviewerName = get(review, 'user.name') || get(review, 'reviewerName') || ''
  const reviewerImage = get(review, 'user.imagePath') || get(review, 'imageUrl') || ''
  const reviewTime = get(review, 'weddingDate')
    ? `แต่งงานเมื่อ ${moment(review.weddingDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}`
    : `เขียนรีวิวเมื่อ ${moment(review.createAt || timestamp(get(review, '_id'))).format('DD/MM/YYYY')}`
  return (
    <ReviewItemWrapper>
      <Reviewer>
        <ReviewerImageWrapper>
          {reviewerImage
            ? <ReviewerImage src={reviewerImage} />
            : <Placeholder>{(Math.ceil(get(review, 'score') || 0)).toFixed(1)}</Placeholder>}
        </ReviewerImageWrapper>
        <ReviewerInfo>
          <ReviewerName>{reviewerName}</ReviewerName>
          <div><ReviewTime>{reviewTime}</ReviewTime></div>
          <ReviewComment>{get(review, 'comment')}</ReviewComment>
        </ReviewerInfo>
      </Reviewer>
    </ReviewItemWrapper>
  )
}

const ReviewItemWrapper = styled.div`
  border-bottom: 1px solid ${getTheme`colorBorder`};
  background-color: white;
  &:last-child { border-bottom: 0px; }
  position: relative;
  @media(min-width: 768px) {
    padding: 20px 30px;
  }
  @media(max-width: 767px) {
    padding: 10px 0px;
  }
`
const Reviewer = styled.div`
  margin-top: 8px;
  margin-bottom: 5px;
  position: relative;
`
const ReviewerImageWrapper = styled.div`
  display: inline-block;
  vertical-align: top;
  border-radius: 50%;
  overflow: hidden;
  width: 48px;
  height: 48px;
`
const ReviewerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: ${getTheme`colorImageBackground`};
  vertical-align: top;
`

const Placeholder = styled.div`
  display: inline-block;
  vertical-align: top;
  text-align: center;
  border-radius: 50%;
  background-image: linear-gradient(-180deg, #FFE13B 0%, #FFBF04 99%);

  font-family: ${getTheme`font1`};
  font-weight: ${getTheme`weightLight`};
  color: white;

  width: 48px;
  height: 48px;
  line-height: 48px;
  font-size: 20px;
`

const ReviewerInfo = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-left: 45px;
  @media(min-width: 768px) {
    margin-left: 45px;
    width: calc(100% - 93px);
  }
  @media(min-width: 415px) and (max-width: 767px) {
    margin-left: 28px;
    width: calc(100% - 76px);
  }
  @media(max-width: 414px) {
    margin-left: 10px;
    width: calc(100% - 170px);
  }
`
const ReviewerName = styled.div`
  font-family: ${getTheme`font1`};
  font-size: 18px;
  color: black;
  line-height: 24px;
`
const ReviewTime = styled.span`
  font-family: ${getTheme`font1`};
  font-size: 14px;
  font-weight: lighter;
  line-height: 21px;
  color: black;
`

const ReviewComment = styled.div`
  font-family: ${getTheme`font1`};
  font-size: 14px;
  font-weight: lighter;
  color: black;
  margin-top: 15px;
  overflow: hidden;
  max-width: 800px;
`

const ReviewStars = styled.div`
  line-height: 19px;
  position: absolute;
  top: ${props => props.isOwner ? '30px' : '0px'};
  right: 0px;
`
const PhotoWrapper = styled(AspectRatioImageContainer)`
  padding-bottom: 100%;
`

const BtnRemove = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
`
const IconRemove = styled.img`
  width: 12px;
  height: 12px;
  vertical-align: top;
`



// WEBPACK FOOTER //
// ./src/containers/Reviews.js